import { Anchor, Radio, Switch, TeamSelect } from "@/components"
import { useStyles } from "@/components/TeamPermissioningFormSection/TeamPermissioningFormSection.styles"
import { Stack, Text } from "@mantine/core"
import { zenDeskHelpCenterPaths } from "app/static/frontend/imports/desktopPaths"
import React from "react"
import { useFormContext } from "react-hook-form"

export const TEAM_PERMISSION_EVERYONE = "everyone"
export const TEAM_PERMISSION_LIMITED_TEAMS = "limited_to_teams"
export const TEAM_PERMISSION_LIMITED_JUST_ME = "limited_just_me"

export const TeamPermissioningFormSection = ({
    availableToJustMe = false,
    showHelpText = true,
    formContainsPartnerToggle = true,
}) => {
    const { classes } = useStyles()
    const formContext = useFormContext()
    const teamPermissioning = formContext.watch("teamPermissioning")
    const shouldRenderPartnerToggle = Boolean(Userdata.partner_uris?.length) && formContainsPartnerToggle

    return (
        <>
            {showHelpText && (
                <Text>
                    You can choose to make this available to everyone at your organization or only for particular teams
                    that you are part of, and manage your default settings in Accounts.{" "}
                    <Anchor target="_blank" href={zenDeskHelpCenterPaths.zdHelpCenterTeamPermissions}>
                        Learn more about Team Permissions
                    </Anchor>
                    .
                </Text>
            )}
            <Radio.Group label="Available to" name="teamPermissioning">
                <Stack spacing="xs">
                    <Radio value={TEAM_PERMISSION_EVERYONE} label="Everyone" />
                    <Radio value={TEAM_PERMISSION_LIMITED_TEAMS} label="Limited to Teams" />
                    {availableToJustMe && <Radio value={TEAM_PERMISSION_LIMITED_JUST_ME} label="Just Me" />}
                </Stack>
            </Radio.Group>
            {teamPermissioning === TEAM_PERMISSION_LIMITED_TEAMS && (
                <TeamSelect name="limitedToTeams" label="Teams" shouldUnregister={false} className={classes.selects} />
            )}

            {shouldRenderPartnerToggle && (
                <Switch
                    label="Is Visible to Partners"
                    name="isVisibleToPartners"
                    tooltip="Choose to share or withhold this with all of your partner organizations."
                />
            )}
        </>
    )
}
